<script>
	import { elasticOut } from 'svelte/easing';
	import Header from './Header.svelte';
	import { push } from 'svelte-spa-router'


    // The params prop contains values matched from the URL
    export let params = {}

    let selected;
    let selected_id;
	let selected_set = [];
	let play_time = 0;
	let time_remaining = 0;
	let draw_set_id = 0;
	let found = false;
	let can_skip = 0;
	let skip_msg = 'Pay ✨100 to skip';
	//$:console.log(selected)

	let mebotStaff = []
	for (let i = 0; i < 9; i++) {
	  mebotStaff.push({
		id: i,
		name: "Frankie",
		watts: "56",
		watt_level: "4",
		img: "/img/mebots-watts.png",
		s: 0,
		text: ''
    	//text: '𒈙',
	  });
	}

	function symbol_jump_out(node, { duration }) {
		return {
			duration,
			css: t => {
				const eased1 = elasticOut(t*2);
				const eased2 = elasticOut((t-0.45)*1.5);

				if(t <= 0.5) {
					return `
				transform: scale(${eased1}) ;
					color: hsl(
						185,
						${Math.min(100, 1000 * t/2)}%,
						75%
					);`
				} else {
					return `
				transform: scale(${eased2}) ;
					color: hsl(
						185,
						${Math.min(400, 1000 * t/2)}%,
						75%
					);`
				}
			}
		};
	}

	function egg_jump_out(node, { duration }) {
		return {
			duration,
			css: t => {
				const eased = elasticOut(t);

				return `
				transform: scale(${eased}) ;
					color: hsl(
						185,
						${Math.min(100, 1000 * t)}%,
						75%
					);`
			}
		};
	}

	let cardBackShowing = false;

	const toggleBackFront = async (e) => {
		// if same card clicked twice to toggle front and back
		if (selected === Number(e.target.dataset.cardId)) {
//			selected = null;
//			cardBackShowing = !cardBackShowing;
		} else {
			cardBackShowing = !cardBackShowing;
			selected = Number(e.target.dataset.cardId)

			if (selected_set.indexOf(selected) === -1) {
				selected_set = [...selected_set, selected];
			}

			if (selected_set.length < 4) {
				//find out the value for the card
				selected_id = selected + 1;
				const res = await fetch('https://api.forever.today/?method=get_draw_value', {
					method: 'POST',
					body: JSON.stringify({
						dash_token,
                		mebot_id,
						selected_id,
						set_id: draw_set_id
            		})
				});

	        	const json = await res.json()
				//console.log(json.data.mebot_img_url);
				//console.log(selected_set);
				//console.log(selected_set.includes(selected))
				mebotStaff[selected].img = json.data.mebot_img_url;
				mebotStaff[selected].s = 1;
				mebotStaff[selected].text = json.data.mebot_symbol;

				if (selected_set.length >= 3) {
				//	getDrawSet()
				}
			}
			getDrawSet()
		}
		//console.log(selected);
	}

	function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let dash_token = params.t
    let mebot_id = params.id

	if (dash_token != '1') {
		if (getCookie("m_dash_token") != '') {
			dash_token = getCookie("m_dash_token")
		}
	}
	
	async function setDrawSet () {
		const res = await fetch('https://api.forever.today/?method=set_draw_set', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id
            })
		})

        const json = await res.json()
		draw_set_id = json.data.set_id;
/*        mebot_img_url = json.data.mebot_img_url
        watt_score = json.data.watt_score
        watt_level = json.data.watt_level
        mebot_msg = json.data.msg*/
    }

	async function getDrawSet () {
		const res = await fetch('https://api.forever.today/?method=get_draw_set', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
				set_id: draw_set_id
            })
		})

        const json = await res.json()
/*        mebot_img_url = json.data.mebot_img_url
        watt_score = json.data.watt_score
        watt_level = json.data.watt_level
        mebot_msg = json.data.msg*/

		for (let i = 0; i < 9; i++) {
	  		mebotStaff[i].img = json.data.tiles[i+1].img
			mebotStaff[i].s = json.data.tiles[i+1].s
			mebotStaff[i].text = json.data.tiles[i+1].mebot_symbol

			if (mebotStaff[i].text != '' && mebotStaff[i].text != 'egg') {
				if (mebotStaff[i].s == 1) {
					found = true;
				}
			}

			if (selected_set.indexOf(i) === -1) {
				if (json.data.tiles[i+1].s == 1) {
					selected_set = [...selected_set, i];
				}
			}
		}
		if (selected_set.length >= 3) {
			for (let i = 0; i < 9; i++) {
				if (selected_set.indexOf(i) === -1) {
					selected_set = [...selected_set, i];
				}
			}
		}

		play_time = json.data.play_time_left;
		time_remaining = play_time;
    }

    function goTop() {
      document.body.scrollIntoView();
    }

    setDrawSet()
    getDrawSet()
    goTop()

	function restartGame () {
		selected_set = [];
		play_time = 0;
		time_remaining = 0;
		//$:console.log(selected)

		mebotStaff = []
		for (let i = 0; i < 9; i++) {
		  mebotStaff.push({
			id: i,
			name: "Frankie",
			watts: "56",
			watt_level: "4",
			img: "/img/mebots-watts.png",
			s: 0,
			text: ''
		  });
		}
		setDrawSet()
		getDrawSet()
	}

	function decrementTimer() {
		if (time_remaining > 0) {
			time_remaining--;
		}
	}

	async function processAdvance() {

		await skipDrawWait();
		console.log('can skip: ' + can_skip);
		if (can_skip == 1) {
			push('/match4/2/' + mebot_id);
		} else {
			skip_msg = ' ✨ Balance too low! ';
		}
	}

	var intervalId = window.setInterval(function() {
		decrementTimer();
	}, 1000);

	async function skipDrawWait() {

		const res = await fetch(
			"https://api.forever.today/?method=skip_draw_wait",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id,
				}),
			}
		);

		const json = await res.json()
		can_skip = json.data.skipped;
	}

	function skipWait() {
//		if (sparkles < 1000) {
//			displayAutopilotNotEnough();
//		} else {
			skipDrawWait();
//		}
	}

</script>

<Header
	header_mebot_id = { mebot_id }
	header_dash_token = { dash_token }
/>
<br><br>
<center>
    <div class="row">
        {#each mebotStaff as {name, watt_level, watts, img, text, s}, i}
            <div class="flip-box" >
				
                <div class="flip-box-inner" class:show-back={ selected_set.includes(i) }>
                    <div class="flip-box-front card">
                        <div class="vertical-center">
                            <img src='/img/mebot_heart.png' on:click={toggleBackFront} data-card-id={i} width='44px' alt='watts'>
                        </div>
                    </div>

                    <div class="flip-box-back container" >

                        {#if text != '' && text != 'egg'}
						<div class="message vertical-center" class:bg_img={ s == 1 } class:show-unselected={ s == 0 } class:show-selected-linked={ s == 1 }>
							{#if s == 1}
							<a class="text-electric vertical-center-symbol" style="-webkit-tap-highlight-color: transparent; transparent; -webkit-touch-callout: none; user-select: none;" href="/#/match4/2/{mebot_id}">
                            <div class="mebot_symbol " style="-webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; display: block; width: 90px; height: 90px; display: flex; align-items:center; text-align: center; justify-content: center; " in:egg_jump_out="{{duration: 2200}}">
								{@html text}
							</div>
							</a>
							{:else}
								<span class="mebot_symbol text-electric vertical-center-symbol">{@html text}</span>
							{/if}
						<!--<img src="/img/mebots-watts.png" alt="" class:show-selected={ s == 1 } class:show-unselected={ s == 0 }>-->
						</div>
						{:else}
							{#if text == 'egg' && s == 1}
								<img in:egg_jump_out="{{duration: 2200}}" src={img} alt={name} class:show-selected-linked={ s == 1 } class:show-unselected={ s == 0 }>
							{:else}
								<img src={img} alt={name} class:show-selected={ s == 1 } class:show-unselected={ s == 0 }>
							{/if}
                        {/if}

                    </div>
                </div>

            </div>
        {/each}
    </div>
	{#if (time_remaining > 0) }
	<!--<span on:click={ restartGame } class="vitals_bold text-electric" style="font-size: 50px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">&#8634;</span>-->
	<span  class="vitals_bold text-electric" style="font-size: 12px; -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; user-select: none; text-decoration: none;">
		{Math.floor(time_remaining/60) < 10 ? '0' : ''}{ Math.floor(time_remaining/60) }:{ time_remaining < 10 ? '0' + time_remaining : (time_remaining > 59 ? ( (time_remaining % 60) < 10 ? '0' + (time_remaining % 60) : (time_remaining % 60)) : time_remaining) }
	</span> &nbsp;
	{#if (found == false) }
	<span>
		<button class="text-electric submenu_active tooltip1" on:click={ processAdvance }> &nbsp; { skip_msg } &nbsp; </button>
	</span>
	{/if}
	{/if}
</center>

<style>
	:global(body, html){
		background-color: #000;
		height: 800px;
		overflow-x: hidden;
	}

	.submenu_active {
        background-color: #202020;
        box-shadow: 0 5px 10px rgb(181, 188, 192);
    }

	.tooltip1 {
		margin-top: 0px;
		font-size: 12px;
		border-radius: 6px;
		border: 1px solid rgb(83, 83, 83);
		background-color: #023c7e86;
		color: #1bffe8ee;
		padding: 3px;
	}

    .text-electric {
		  text-shadow: 0 0 40px rgba(192, 253, 255, 0.9), 0 0 32px rgba(65, 255, 249, 0.98);
		  font-family: arial;
          color: hsl(185, 97%, 75%);
	}

	.row {
		display: flex;
		flex-wrap: wrap;
        width: 350px;
		justify-content: center;
		margin-bottom: 10%;
	}
	/* The flip box container - set the width and height to whatever you want. We have added the border property to demonstrate that the flip itself goes out of the box on hover (remove perspective if you don't want the 3D effect */
	.flip-box {
		background-color: transparent;
		width: 95px;
		height: 95px;
		margin: 0 8px 15px;
		border: 0px solid #f1f1f1;
		perspective: 1000px; /* Remove this if you don't want the 3D effect */
	}

	/* This container is needed to position the front and back side */
	.flip-box-inner {
		position: relative;
		width: 100%;
		height: 100%;
		text-align: center;
		transition: transform 0.8s;
		transform-style: preserve-3d;
	}

	/* Do an horizontal flip when you move the mouse over the flip box container */
/* 	.flip-box:hover .flip-box-inner {
		transform: rotateY(180deg);
	}*/
	
	.show-back {
		transform: rotateY(180deg);
	}

	.show-selected {
		background-color: rgb(26, 26, 26);
		border-radius: 10px;
		box-shadow: 0 0 10px rgb(88, 89, 89), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.show-selected-linked
	{
		background-color: rgb(26, 26, 26);
		border-radius: 10px;
		box-shadow: 0 0 10px rgb(0, 255, 255), 0 0 20px rgba(130, 132, 132, 0.819);
	}

	.show-unselected {
		opacity: 40%;
	}

	/* Position the front and back side */
	.flip-box-front, .flip-box-back {
		position: absolute;
		width: 100%;
		height: 100%;
		-webkit-backface-visibility: hidden; /* Safari */
		backface-visibility: hidden;
	}

	/* Style the front side */
	.flip-box-front {
/*		background-color: rgba(247, 233, 26, 0.932);*/
      background-color: #ffaf1bee;
	}

    .vertical-center {
        margin: 0;
        position: absolute;
        top: 52%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .message {
        margin: 0;
        position: absolute;
        top: 40%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

	/* Style the back side */
	.flip-box-back {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		color: white;
		width: 89px;
		height: 95px;
		transform: rotateY(180deg) translateX(6px);
	}

	img {
		max-height: 90%;
	}	

	/* Add some shadows to create a card effect */
	.card {
        border-radius: 10px;
        color: rgb(194, 133, 2);
		box-shadow: 0 4px 8px 0 rgba(189, 140, 104, 0.2);
	}

	/* Some left and right padding inside the container */
	.container {
		padding: 5px;
	}

	.bg_img {
		margin-top: 5px;
 		background-color: #131313;
		background-color: rgb(26, 26, 26);
		border-radius: 10px;
		width: 90px;
		height: 85px;
	}

    .vertical-center-symbol {
		margin: 0;
        position: absolute;
        top: 46%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

	.mebot_symbol {
		font-size: 24px;
	}
</style>
